module.exports = __webpack_public_path__ + "static/media/chanel_rsvp_banner_mobile@2x.20325c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chanel_rsvp_banner_mobile@2x.jpg
// module id = 368
// module chunks = 0